<template>
    <div>
        <div v-if="flag" style="overflow-y: auto; height: 85vh; display: flex; align-items: center; justify-content: center">
            <el-button @click="flag = !flag" icon="el-icon-warning-outline" type="primary">暂无数据点击添加</el-button>
        </div>

        <el-form class="form-wrap" v-else>
            <el-form-item label="服务人员身份证人像面:" label-width="200px">
                <el-image
                    :preview-src-list="srcList"
                    v-if="img_url.id_card_portrait_imageUrl"
                    :src="img_url.id_card_portrait_imageUrl"
                    class="avatar"
                ></el-image>
                <el-upload
                    :class="img_url.id_card_portrait_imageUrl ? 'border-none' : ''"
                    class="avatar-uploader"
                    :action="img_upload_url"
                    :show-file-list="false"
                    :before-upload="idPortraitSuccess"
                    :headers="img_headers"
                >
                    <el-button
                        slot="trigger"
                        v-if="img_url.id_card_portrait_imageUrl"
                        @click="img_url.id_card_portrait_imageUrl = ''"
                        style="width: 100px; margin-top: 10px"
                        >更换图片</el-button
                    >
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>

            <el-form-item label="服务人员身份证国徽面:" label-width="200px">
                <el-image
                    :preview-src-list="srcList"
                    v-if="img_url.id_card_china_imageUrl"
                    :src="img_url.id_card_china_imageUrl"
                    class="avatar"
                ></el-image>

                <el-upload
                    :class="img_url.id_card_china_imageUrl ? 'border-none' : ''"
                    class="avatar-uploader"
                    :action="img_upload_url"
                    :show-file-list="false"
                    :before-upload="idChinaSuccess"
                    :headers="img_headers"
                >
                    <el-button
                        slot="trigger"
                        v-if="img_url.id_card_china_imageUrl"
                        @click="img_url.id_card_china_imageUrl = ''"
                        style="width: 100px; margin-top: 10px"
                        >更换图片</el-button
                    >
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>

            <el-form-item label="驾驶证图片:" label-width="200px">
                <el-image
                    :preview-src-list="srcList"
                    v-if="img_url.driver_card_imageUrl"
                    :src="img_url.driver_card_imageUrl"
                    class="avatar"
                ></el-image>

                <el-upload
                    :class="img_url.driver_card_imageUrl ? 'border-none' : ''"
                    class="avatar-uploader"
                    :action="img_upload_url"
                    :show-file-list="false"
                    :before-upload="driverCardSuccess"
                    :headers="img_headers"
                >
                    <el-button
                        slot="trigger"
                        v-if="img_url.driver_card_imageUrl"
                        @click="img_url.driver_card_imageUrl = ''"
                        style="width: 100px; margin-top: 10px"
                        >更换图片</el-button
                    >
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>

            <el-form-item label="手持身份证图片:" label-width="200px">
                <el-image
                    :preview-src-list="srcList"
                    v-if="img_url.id_card_hold_imageUrl"
                    :src="img_url.id_card_hold_imageUrl"
                    class="avatar"
                ></el-image>

                <el-upload
                    :class="img_url.id_card_hold_imageUrl ? 'border-none' : ''"
                    class="avatar-uploader"
                    :action="img_upload_url"
                    :show-file-list="false"
                    :before-upload="idHoldSuccess"
                    :headers="img_headers"
                >
                    <el-button
                        slot="trigger"
                        v-if="img_url.id_card_hold_imageUrl"
                        @click="img_url.id_card_hold_imageUrl = ''"
                        style="width: 100px; margin-top: 10px"
                        >更换图片</el-button
                    >
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>

            <p class="verify_remarks" style="margin-bottom: 15px" v-if="returnData">
                <span style="display: inline-block; width: 120px; text-align: right">审核判定状态: </span>
                <el-tag :type="verify_status === '1' ? '' : 'danger'" style="margin-left: 10px">
                    {{ verify_status === '0' ? '待判定' : verify_status === '1' ? '已通过' : '已拒绝' }}</el-tag
                >
            </p>

            <p class="verify_remarks" style="margin-bottom: 15px" v-if="returnData">
                <span style="display: inline-block; width: 120px; text-align: right">审核原因： </span>
                <span style="margin-left: 10px">{{ verify_remarks }}</span>
            </p>

            <el-form-item label="真实姓名:" label-width="120px">
                <el-input v-model="submit_data.real_name" :placeholder="submit_rules.real_name.placeholder" style="width: 80%"> </el-input>
            </el-form-item>

            <el-form-item label="身份证号码:" label-width="120px">
                <el-input v-model="submit_data.id_card" :placeholder="submit_rules.id_card.placeholder" style="width: 80%"> </el-input>
            </el-form-item>

            <el-form-item label="驾驶证类型:" label-width="120px">
                <el-select
                    v-model="value_driver_card"
                    placeholder="请选择驾驶证类型"
                    style="width: 150px; margin-right: 20px"
                    @visible-change="driverCardVisibleChange"
                    @change="driverCardChange"
                >
                    <el-option v-for="(item, index) in driverCardList" :label="item.name" :value="item.type"> </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="驾驶证领取时间:" label-width="120px">
                <el-date-picker
                    type="date"
                    :placeholder="submit_rules.driver_time.placeholder"
                    v-model="submit_data.driver_time"
                    value-format="yyyy-MM-dd"
                    style="width: 80%"
                ></el-date-picker>
            </el-form-item>

            <el-form-item label="备注:" label-width="120px">
                <el-input v-model="submit_data.remarks" :placeholder="submit_rules.remarks.placeholder" style="width: 80%"> </el-input>
            </el-form-item>
            <div style="display: flex; justify-content: center">
                <el-button type="primary" @click="examineonSubmit">保存</el-button>
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
var _this;
import { config } from '../../../utils/config'; // 配置
import axios from 'axios'; // AJAX封装类
import bus from '../../common/bus.js';

export default {
    props: {
        driverShow: Boolean,
        data: ''
    },
    watch: {
        driverShow: {
            immediate: true,
            handler: function (newData, oldData) {
                // 获取上传图片的地址
                this.img_upload_url = config.axios_imgURL;

                // 清空表单数据
                for (const key in this.submit_data) {
                    this.submit_data[key] = '';
                }

                // 清空图片的路径
                for (const key in this.img_url) {
                    this.img_url[key] = '';
                }

                // 清空驾驶证下拉的显示信息
                this.value_driver_card = '';

                // 清空审核判定信息
                this.verify_remarks = '';
                this.verify_status = '';

                if (newData) {
                    this.$post('/driver/getDriverVerifyDetails', {
                        driver_code: this.data
                    }).then((res) => {
                        // 在submit_data对象中赋值driver_code
                        this.submit_data.driver_code = this.data;

                        // 判断返回的data中是否有值
                        if (res.data == null) {
                            this.flag = true;

                            // 返回的data中没有值在returnData中做个标记
                            this.returnData = false;
                            console.log('没有添加过审核');
                        } else {
                            console.log('编辑审核内容');

                            this.flag = false;

                            // 返回的data中的值赋给submit_data对象,并在returnData中做标记
                            this.submit_data.real_name = res.data.real_name;
                            this.submit_data.id_card = res.data.id_card;
                            this.submit_data.driver_card_mode = res.data.driver_card_mode;
                            this.submit_data.driver_time = res.data.driver_time.Ymd;
                            this.submit_data.remarks = res.data.remarks;

                            this.submit_data.id_card_portrait_hash = res.data.id_card_portrait.hash;
                            this.submit_data.id_card_china_hash = res.data.id_card_china.hash;
                            this.submit_data.driver_card_hash = res.data.driver_card.hash;
                            this.submit_data.id_card_hold_hash = res.data.id_card_hold.hash;
                            this.verify_status = res.data.verify_status;
                            this.verify_remarks = res.data.verify_remarks;

                            this.value_driver_card = res.data.driver_card_mode;

                            // 图片路径
                            this.img_url.id_card_portrait_imageUrl = res.data.id_card_portrait.url;
                            this.img_url.id_card_china_imageUrl = res.data.id_card_china.url;
                            this.img_url.driver_card_imageUrl = res.data.driver_card.url;
                            this.img_url.id_card_hold_imageUrl = res.data.id_card_hold.url;

                            this.srcList.length = 0;
                            this.srcList.push(this.img_url.id_card_portrait_imageUrl);
                            this.srcList.push(this.img_url.id_card_china_imageUrl);
                            this.srcList.push(this.img_url.driver_card_imageUrl);
                            this.srcList.push(this.img_url.id_card_hold_imageUrl);

                            // 返回的data中有值在returnData中做个标记
                            this.returnData = true;
                        }
                    });
                }
            }
        }
    },
    data() {
        return {
            // 驾驶证下拉
            value_driver_card: '',
            driverCardList: [],

            // 图片上传地址
            img_upload_url: '',

            srcList: [],

            // 没有数据时提示
            flag: true,

            //审核判定状态
            verify_status: '',

            //审核原因
            verify_remarks: '',

            //上传图片
            img_url: {
                id_card_portrait_imageUrl: '',
                id_card_china_imageUrl: '',
                driver_card_imageUrl: '',
                id_card_hold_imageUrl: ''
            },

            //压缩质量
            imgQuality: 0.5,

            // 表单数据
            submit_data: {
                driver_code: '',
                real_name: '',
                id_card: '',
                driver_card_mode: '',
                driver_time: '',
                remarks: '',
                // 身份证人像面
                id_card_portrait_hash: '',
                // 身份证国徽面
                id_card_china_hash: '',
                // 驾驶证
                driver_card_hash: '',
                // 手持身份证
                id_card_hold_hash: ''
            },

            submit_rules: {
                driver_code: {
                    placeholder: '请输入司机编码',
                    rules: {
                        required: true,
                        message: '司机编码，14-20位',
                        regulation: 'special',
                        rulesData: 'driver_code'
                    }
                },
                real_name: {
                    placeholder: '请输入真实姓名',
                    rules: {
                        required: true,
                        message: '真实姓名需在4个汉字之内',
                        regulation: 'elt',
                        rulesData: 4
                    }
                },
                driver_time: {
                    placeholder: '请输入驾驶证领取时间',
                    rules: {
                        required: true,
                        message: '请输入驾驶证领取时间',
                        regulation: 'elt',
                        rulesData: 30
                    }
                },
                remarks: {
                    placeholder: '备注为200字以内',
                    rules: {
                        required: false,
                        message: '备注为200字以内',
                        regulation: 'elt_str',
                        rulesData: 200
                    }
                },
                id_card: {
                    placeholder: '请输入身份证号码',
                    rules: {
                        required: true,
                        message: '身份证信息输入不正确',
                        regulation: 'special',
                        rulesData: 'id_card'
                    }
                },
                driver_card_mode: {
                    placeholder: '请输入驾驶证型号',
                    rules: {
                        required: true,
                        message: '驾驶证型号英文需要大写',
                        regulation: 'special',
                        rulesData: 'driverLicense'
                    }
                },
                id_card_portrait_hash: {
                    placeholder: '身份证人像面',
                    rules: {
                        required: true,
                        message: '身份证人像面哈希值错误',
                        regulation: 'lt_str',
                        rulesData: 'json_array'
                    }
                },
                id_card_china_hash: {
                    placeholder: '身份证国徽面',
                    rules: {
                        required: true,
                        message: '身份证国徽面哈希值错误',
                        regulation: 'lt_str',
                        rulesData: 'json_array'
                    }
                },
                driver_card_hash: {
                    placeholder: '驾驶证',
                    rules: {
                        required: true,
                        message: '驾驶证哈希值错误',
                        regulation: 'lt_str',
                        rulesData: 'json_array'
                    }
                },
                id_card_hold_hash: {
                    placeholder: '手持身份证',
                    rules: {
                        required: true,
                        message: '手持身份证哈希值错误',
                        regulation: 'lt_str',
                        rulesData: 'json_array'
                    }
                }
            },

            // 上传图片的请求头
            img_headers: {
                token: '',
                'hash-key': '',
                platform: 'pc',
                'app-version': 'admin',
                port: 'admin',
                'city-tag': localStorage.getItem('city_tag'),
                'service-tag':localStorage.getItem('service_tag')
            },

            // 用来标记返回的data数据是否为null
            returnData: false

            // 用来存放身份证人像面的哈希值
            // id_card_portrait_arrway: [],
            // 用来存放身份证国徽面的哈希值
            // id_card_china_arrway: [],
            // 用来存放驾驶证的哈希值
            // driver_card_arrway: [],
            // 用来存放手持身份证的哈希值
            // id_card_hold_arrway: [],
        };
    },
    created() {
        _this = this;
    },
    methods: {
        // 驾驶证下拉点击触发
        driverCardVisibleChange(e) {
            // 更改axios请求的baseURL
            // axios.defaults.baseURL = config.axios_normalURL;
            // 判断下拉框状态是否展开并且是否请求过数据
            if (e && _this.driverCardList.length < 1) {
                _this
                    .$post('/driver/getDriverCardMode',{},{},'normal')
                    .then((res) => {
                        // 还原axios请求的baseURL
                        // axios.defaults.baseURL = config.axios_baseURL;
                        _this.driverCardList = res.data;
                    })
                    .catch((res) => {});
            }
            // 还原axios请求的baseURL
            // axios.defaults.baseURL = config.axios_baseURL;
        },

        // 驾驶证下拉选中触发
        driverCardChange(val) {
            _this.submit_data.driver_card_mode = val;
        },

        // 判断图片的img_url是否存在
        imgUrlDeg() {
            if (
                _this.img_url.id_card_portrait_imageUrl !== '' &&
                _this.img_url.id_card_china_imageUrl !== '' &&
                _this.img_url.driver_card_imageUrl !== '' &&
                _this.img_url.id_card_hold_imageUrl !== ''
            ) {
                return true;
            } else {
                _this.$message.error({
                    message: '未上传图片信息',
                    duration: 1500
                });
                return false;
            }
        },

        // 审核信息提交
        examineonSubmit() {
            // 判断img_url是否有值

            if (_this.imgUrlDeg()) {
                //删除存放哈希值数组中的最后一项
                // _this.id_card_portrait_arrway.pop();

                // _this.id_card_china_arrway.pop();

                // _this.driver_card_arrway.pop();

                // _this.id_card_hold_arrway.pop();

                // 判断标记
                if (_this.returnData) {
                    // 请求编辑审核接口
                    _this.submitPost('/driver/editDriverVerifySubmit');
                } else {
                    // 请求添加审核接口
                    _this.submitPost('/driver/addDriverVerifySubmit');
                }
            }
        },

        // 提交按钮的请求方法
        submitPost(url) {
            _this
                .$post(url, _this.submit_data, _this.submit_rules)
                .then((res) => {
                    _this.$message.success({
                        message: res.msg,
                        duration: 1500
                    });

                    _this.closeDialog();

                    _this.$emit('closeDialog');
                })
                .catch((err) => {});
        },

        // 删除图片请求
        // delImg() {
        //   //将4个存放哈希值得数组合并成一个数组用作向接口发送请求删除
        //   var delData = [];
        //   delData = delData
        //     .concat(_this.id_card_portrait_arrway)
        //     .concat(_this.id_card_china_arrway)
        //     .concat(_this.driver_card_arrway)
        //     .concat(_this.id_card_hold_arrway);

        //   // 判断delData是否有数据
        //   if (delData.length > 0) {
        //     //改变axios的baseURL
        //     axios.defaults.baseURL = config.axios_normalURL; //请求normal url
        //     // 删除图片请求
        //     delData = JSON.stringify(delData)

        //     _this.$post(
        //         "/qiniu/delete", {
        //           port: 'admin',
        //           img_hash_delete_array: delData
        //         }
        //       )
        //       .then(res => {
        //         console.log('图片成功删除');

        //       }).catch((err) => {

        //       })
        //     // 还原axios的baseURL
        //     axios.defaults.baseURL = config.axios_baseURL; //请求base url
        //   }
        // },

        // 关闭方法
        closeDialog() {
            _this.flag = true;
            // 删除图片请求
            // _this.delImg();
            // 执行父组件关闭方法
            _this.$emit('closeDialog');
        },

        // 身份证人像面上传成功后执行 两个参数，file代表上传的文件，isSave代表上传的policyName参数是临时文件还是永久文件。permanent（永久文件）temporary（临时文件）
        idPortraitSuccess(file) {
            _this.$uploadImage({ file: file, isSave: 'permanent' }).then((res) => {
                // console.log(file, '1============');
                console.log(res, 'res');

                // 将返回的哈希值存到submit_data对象
                _this.submit_data.id_card_portrait_hash = res.hash;

                // 设置img标签显示的图片路径
                _this.img_url.id_card_portrait_imageUrl = URL.createObjectURL(file);

                //上传图片后点击预览
                _this.srcList.push(String(_this.img_url.id_card_portrait_imageUrl));
            });

            return false;
        },

        // 身份证国徽面上传成功后执行
        idChinaSuccess(file) {
            _this.$uploadImage({ file: file, isSave: 'permanent' }).then((res) => {
                // console.log(file, '1============');

                // 将返回的哈希值存到submit_data对象
                _this.submit_data.id_card_china_hash = res.hash;

                // 设置img标签显示的图片路径
                _this.img_url.id_card_china_imageUrl = URL.createObjectURL(file);

                //上传图片后点击预览
                _this.srcList.push(String(_this.img_url.id_card_china_imageUrl));
            });

            return false;
        },

        // 驾驶证上传成功后执行
        driverCardSuccess(file) {
            _this.$uploadImage({ file: file, isSave: 'permanent' }).then((res) => {
                // console.log(file, '1============');

                // 将返回的哈希值存到submit_data对象
                _this.submit_data.driver_card_hash = res.hash;

                // 设置img标签显示的图片路径
                _this.img_url.driver_card_imageUrl = URL.createObjectURL(file);

                //上传图片后点击预览
                _this.srcList.push(String(_this.img_url.driver_card_imageUrl));
            });

            return false;
        },

        // 手持身份证上传成功后执行
        idHoldSuccess(file) {
            _this.$uploadImage({ file: file, isSave: 'permanent' }).then((res) => {
                // console.log(file, '1============');

                // 将返回的哈希值存到submit_data对象
                _this.submit_data.id_card_hold_hash = res.hash;

                // 设置img标签显示的图片路径
                _this.img_url.id_card_hold_imageUrl = URL.createObjectURL(file);

                //上传图片后点击预览
                _this.srcList.push(String(_this.img_url.id_card_hold_imageUrl));
            });

            return false;
        }
    }
};
</script>

<style scoped>
.form-wrap {
    height: calc(100vh - 100px);
    overflow-y: auto;
    margin-top: 20px;
}
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 100px;
    height: 100px;
    display: block;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}

.avatar-uploader img {
    display: block;
    width: 100%;
    height: 100%;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.verify_remarks {
    font-size: 14px;
    color: #606266;
}
</style>